/* ============================================================
   La Nuit — wishlist.js
   Hearts on product cards + PDP. Stores in localStorage:
     KEY: 'lanuit-wishlist' = array of { id, handle }
   The wishlist page (assets/wishlist-page.js) reads handles and
   fetches each card via /products/<handle>?view=card.
   ============================================================ */
(function () {
  const KEY = 'lanuit-wishlist';

  function read() {
    try {
      const raw = JSON.parse(localStorage.getItem(KEY)) || [];
      if (raw.length > 0 && typeof raw[0] !== 'object') {
        return raw.map(id => ({ id: parseInt(id, 10), handle: null }));
      }
      return raw;
    } catch (e) { return []; }
  }

  function write(items) {
    localStorage.setItem(KEY, JSON.stringify(items));
    document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { items }, bubbles: true }));
  }

  function has(id) { return read().some(it => it.id === id); }

  function notify(message, variant) {
    if (window.LaNuit && typeof window.LaNuit.toast === 'function') {
      window.LaNuit.toast(message, { variant, iconHTML: '<svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 21s-7-4.35-9.5-9.05A5.5 5.5 0 0 1 12 6a5.5 5.5 0 0 1 9.5 5.95C19 16.65 12 21 12 21Z"/></svg>' });
    }
  }

  function titleFor(id) {
    const btn = document.querySelector(`[data-wishlist-toggle][data-product-id="${id}"]`);
    if (!btn) return null;
    const card = btn.closest('.card-product');
    const t = card && card.querySelector('.card-product__title');
    if (t) return t.textContent.trim();
    const pdpTitle = document.querySelector('.main-product__title');
    if (pdpTitle) return pdpTitle.textContent.trim();
    return null;
  }

  function add(id, handle) {
    const items = read();
    if (items.some(it => it.id === id)) return items;
    items.unshift({ id, handle: handle || null });
    write(items);
    const t = titleFor(id);
    notify(t ? `Added "${t}" to your wishlist` : 'Added to your wishlist', 'success');
    return items;
  }

  function remove(id) {
    const t = titleFor(id);
    const items = read().filter(it => it.id !== id);
    write(items);
    notify(t ? `Removed "${t}" from your wishlist` : 'Removed from your wishlist', 'info');
    return items;
  }

  function toggle(id, handle) {
    return has(id) ? remove(id) : add(id, handle);
  }

  function syncButton(btn, items) {
    const id = parseInt(btn.dataset.productId, 10);
    const isOn = items.some(it => it.id === id);
    btn.setAttribute('aria-pressed', String(isOn));
    btn.setAttribute('aria-label', isOn
      ? (btn.dataset.removeLabel || 'Remove from wishlist')
      : (btn.dataset.addLabel || 'Add to wishlist'));
    btn.classList.toggle('is-active', isOn);
  }

  function syncAll() {
    const items = read();
    document.querySelectorAll('[data-wishlist-toggle]').forEach(btn => syncButton(btn, items));
    document.querySelectorAll('[data-wishlist-header-count]').forEach(el => {
      el.textContent = String(items.length);
      if (items.length > 0) { el.hidden = false; el.classList.remove('is-empty'); }
      else { el.hidden = true; el.classList.add('is-empty'); }
    });
  }

  // Bubbling click handler — wishlist-page.js intercepts in the capture
  // phase to insert its confirm dialog when on the wishlist page.
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn || e.defaultPrevented) return;
    if (e.detail && e.detail.__lanuitConfirmed) {
      // already approved by the page-level confirm flow
    }
    e.preventDefault();
    const id = parseInt(btn.dataset.productId, 10);
    const handle = btn.dataset.productHandle || null;
    if (!id) return;
    toggle(id, handle);
    syncAll();
  });

  syncAll();
  document.addEventListener('wishlist:updated', syncAll);

  // Expose for the wishlist page renderer + page-level removers
  window.LaNuit = window.LaNuit || {};
  window.LaNuit.wishlist = { read, write, has, add, remove, toggle, syncAll };
})();
